import styled, { css } from 'styled-components';
import { calcOpacity } from 'utils/calcOpacity';

export const TagWrapper = styled.div<{ scrolledValue: number; isSmallProfile?: boolean }>`
  ${({ theme, scrolledValue, isSmallProfile }) => css`
    display: flex;
    gap: ${theme.spacing.km2};
    position: relative;
    z-index: 19;
    transition: opacity 0s;
    margin: 0px 0px ${theme.spacing.km3};

    ${!isSmallProfile
      ? css`
          opacity: ${calcOpacity(84, scrolledValue, 64)};
        `
      : css`
          opacity: ${calcOpacity(142, scrolledValue, 124)};
          justify-content: center;
        `}
  `}
`;
